// Settings for axios requests
export const apiHost = process.env.REACT_APP_API_HOST || 'exoplanetgames.ru';

export const path_to_site = `https://${apiHost}/adminka_project/siteRequestsListener.php`;
